import { render, staticRenderFns } from "./TrialSuggestionCard.vue?vue&type=template&id=2e1ee446&scoped=true&"
import script from "./TrialSuggestionCard.vue?vue&type=script&lang=js&"
export * from "./TrialSuggestionCard.vue?vue&type=script&lang=js&"
import style0 from "./TrialSuggestionCard.vue?vue&type=style&index=0&id=2e1ee446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ee446",
  null
  
)

export default component.exports